import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        indexChannel: null, //导航栏首页信息
        columnList: [], //栏目集合
        showPop: false, // 辟谣入口弹窗
        freshSearchFlag: false, // 刷新搜索结果标志
        loadingShow: true, // loading展示
        navChannelList: [], // 顶部导航频道列表
        isSubject:false,//是否是专题
        isSpecial: -1, // -1默认状态 0不是特殊频道 1是特殊频道
    },
    mutations: {
        setNavChannelList(state, data) {
            state.navChannelList = data
        },
        setColumnList(state, data) {
            state.columnList = data
        },
        setIndexChannel(state, data) {
            state.indexChannel = data
        },
        setShowPop(state, flag) {
            state.showPop = flag
        },
        freshSearch(state, data) {
            state.freshSearchFlag = data
        },
        setLoadingShow(state, data) {
            state.loadingShow = data
        },
        setIsSubject(state, flag) {
            state.isSubject = flag
        },
        setIsSpecial(state, data) {
            state.isSpecial = data
        },
    }
})